import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { config } from '../../../../config';
import { getMarketHeaders } from '../../../../utils/market';
import './LoginForm.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');

    if (!email) {
      setError('Please enter your email address.');
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post(
        `${config.API_BASE}/api/forgot-password`,
        { email, userType: 'customer' },
        { headers: getMarketHeaders() }
      );
      setMessage(response.data?.message || 'Check your email for a reset link.');
    } catch (err) {
      setError(err.response?.data?.message || 'Unable to send reset link. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signin-container">
      <div className="signin-card">
        <div className="signin-header">
          <h1 className="signin-title">Farmers Marketspace</h1>
          <p className="signin-subtitle">Reset your password</p>
        </div>

        <form onSubmit={handleSubmit} className="signin-form">
          <div className="form-group">
            <label htmlFor="email" className="form-label">Email Address</label>
            <input
              type="email"
              className="form-input"
              id="email"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          {error && <p style={{ color: '#dc2626', marginBottom: 16 }}>{error}</p>}
          {message && <p style={{ color: '#059669', marginBottom: 16 }}>{message}</p>}

          <button type="submit" className="signin-button" disabled={loading}>
            {loading ? 'Sending...' : 'Send Reset Link'}
          </button>
        </form>

        <div className="register-section">
          <Link to="/account/signin" className="register-link" style={{ marginLeft: 0 }}>
            Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
